import type Owner from '@ember/owner';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { EmptyScreensBaseArgs } from 'webapp/components/empty-screens/base';
import EmptyScreensBaseComponent from 'webapp/components/empty-screens/base';

export default class EmptyScreensMyGoalsComponent extends EmptyScreensBaseComponent<EmptyScreensBaseArgs> {
	@service('analytics') declare analyticsService: Service.Analytics;

	trackingOrigin = 'my-goals';

	constructor(owner: Owner, args: EmptyScreensBaseArgs) {
		super(owner, args);

		this.titleText = 'Track your own goals';
		this.descText = 'Monitor progress and increase the chances of hitting your targets.';

		this.topImageLightUrl = '/images/placeholders/goals.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/goals.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-goals.svg';

		this.mainActions = [
			{
				action: this.create,
				icon: 'Plus',
				text: 'New goal',
				isForCreating: true,
			},
		];
		this.skeletonImage = '/images/svg/skeleton-screens/goal.svg';

		this.arrowText =
			'Click here to create your goal, or view your teammates goals on the Company goals page';
	}
}
